/**
 * HeadingBlock: `heading` content block.
 *
 * data: { text, level } where `level` is 2 or 3.
 *
 * Renders a section heading. An unknown / missing `level` falls back to 2 so
 * a half-authored block still produces a valid heading. With no `text` the
 * block renders nothing.
 */
import React from 'react';
import PropTypes from 'prop-types';

export default function HeadingBlock({ data }) {
    const { text, level } = data || {};

    if (!text) {
        return null;
    }

    // Constrain to the supported levels (2, 3); default to h2. The heading
    // type scale + color live in Content.css (.content-heading) so the
    // hierarchy is consistent across blocks rather than Bootstrap-default.
    const Tag = level === 3 ? 'h3' : 'h2';
    const headingClass =
        level === 3
            ? 'content-heading content-heading--h3 text-primary'
            : 'content-heading content-heading--h2 text-primary';

    return <Tag className={headingClass}>{text}</Tag>;
}

HeadingBlock.propTypes = {
    data: PropTypes.shape({
        text: PropTypes.string,
        level: PropTypes.oneOf([2, 3]),
    }),
};

HeadingBlock.defaultProps = {
    data: {},
};
